import { LocationSearchItem } from '@deckee/api-app-main';
import { NavList } from '@deckee/deck-hand';
import React, { FC } from 'react';
import { useTheme } from 'styled-components';
import { getLayerDefinitions } from '../../../../../services/map-layer';
import IconWithTextLockup from '../../../../lockups/IconWithTextLockup/IconWithTextLockup';
import BlueCircleWrapper from '../../../../shared/BlueCircleWrapper/BlueCircleWrapper';
import { ReactSvg, location } from '../../../../shared/vector-images';

export type SearchLocationCardItem = Pick<
  LocationSearchItem,
  'title' | 'markerType' | 'placeDescription'
>;

export interface SearchLocationCardProps extends SearchLocationCardItem {
  onSelectCard: (event: React.MouseEvent) => void;
}

const LocationSearchCard: FC<SearchLocationCardProps> = ({
  title,
  markerType,
  placeDescription,
  onSelectCard,
}) => {
  const theme = useTheme();

  // Since we don't want to create a layer for beach emergency numbers, we're going to manually add them here
  const beachNumberMarkerDisplayName =
    markerType === 'beachEmergencyNumberMarker'
      ? 'Beach emergency number'
      : null;
  const markerConfig = getLayerDefinitions()[markerType || ''];

  return (
    <NavList.Item chevron onClick={onSelectCard}>
      <IconWithTextLockup
        heading={title}
        description={
          placeDescription ||
          markerConfig?.displayName ||
          beachNumberMarkerDisplayName
        }
        emphasis="heading"
        useEllipsis
        image={
          <BlueCircleWrapper
            bg={
              markerConfig?.icon?.iconColor
                ? markerConfig?.icon?.markerColor
                : 'white'
            }
          >
            <ReactSvg
              toDisplay={
                markerConfig?.icon?.baseShape
                  ? markerConfig.icon?.baseShape()
                  : location()
              }
              options={{
                fillColor:
                  markerConfig?.icon?.iconColor || theme.colors.secondary,
              }}
              width={24}
              height={24}
            />
          </BlueCircleWrapper>
        }
      />
    </NavList.Item>
  );
};
export default LocationSearchCard;
